import { products } from "../../data/products.js";
import { siteLinks } from "../../data/site.js";

export function Navbar() {
  const productLinks = products.map((product) => `
    <a href="${product.route}" data-route>
      <strong>${product.name}</strong>
      <small>${product.shortDescription}</small>
    </a>
  `).join("");
  return `
    <header class="site-header" data-header>
      <div class="site-container nav-shell">
        <a href="/" class="brand-link" data-route aria-label="GR SoftMedia, inicio">
          <img src="/assets/gr-softmedia-logo-crop.png" alt="GR SoftMedia" width="634" height="324" />
        </a>
        <button class="nav-toggle" type="button" aria-expanded="false" aria-controls="site-navigation" aria-label="Abrir menú" data-nav-toggle>
          <span></span><span></span><span></span>
        </button>
        <nav id="site-navigation" class="site-nav" aria-label="Navegación principal" data-nav>
          <div class="nav-dropdown" data-dropdown>
            <button type="button" aria-expanded="false" data-dropdown-toggle>Productos <span class="nav-chevron" aria-hidden="true"></span></button>
            <div class="product-menu" data-dropdown-menu aria-label="Productos de GR SoftMedia">
              ${productLinks}
            </div>
          </div>
          <a href="/#soluciones" data-route>Soluciones</a>
          <a href="/#proceso" data-route>Cómo trabajamos</a>
          <a href="/#nosotros" data-route>Nosotros</a>
          <a href="/#contacto" data-route>Contacto</a>
          <a class="nav-login" href="${siteLinks.login}">Iniciar sesión</a>
          <a class="button button-primary nav-cta" href="${siteLinks.requestDemo}">Solicitar demostración</a>
        </nav>
      </div>
    </header>
  `;
}
